import { combine, createEvent, createStore, sample } from 'effector';

const $width = createStore<number>(window.innerWidth);
const changeWidthEvent = createEvent<UIEvent>();
sample({ clock: changeWidthEvent, fn: () => window.innerWidth, target: $width });

window.addEventListener('resize', changeWidthEvent);

const sizes = {
    mobile: {
        from: 0,
    },
    tablet: {
        from: 768,
    },
    desktop: {
        from: 992,
    },
};

export const $isMobile = $width.map((width) => width < sizes.tablet.from);
export const $isTablet = $width.map((width) => width >= sizes.tablet.from && width < sizes.desktop.from);
export const $isDesktop = $width.map((width) => width >= sizes.desktop.from);
export const $deviceType = $width.map((width) => {
    if (width < sizes.tablet.from) {
        return 'mobile';
    }
    if (width >= sizes.desktop.from) {
        return 'desktop';
    }
    return 'tablet';
});
export const $isIOS = createStore<boolean>(
    (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (/MacIntel/.test(navigator.platform) && navigator.maxTouchPoints > 1)) &&
        !(window as any).MSStream,
);
export const $isAndroid = createStore<boolean>(/Android/.test(navigator.userAgent) && !(window as any).MSStream);
export const $deviceParams = combine({
    isMobile: $isMobile,
    isTablet: $isTablet,
    isDesktop: $isDesktop,
    type: $deviceType,
    isIOS: $isIOS,
    isAndroid: $isAndroid,
});
